import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {SideMenuService} from "../../../../../services/side-menu.service";
import {MultiClaimDocumentsComponent} from "../../../../multi-claim-documents/multi-claim-documents.component";
import { ClaimService } from '../../../../../services/claim.service';
import { DocumentHelperService } from '../../../../../services/document-helper.service';
import { TransactionInfoService } from '../../../../../services/transaction-info.service';
import { HttpClient } from '@angular/common/http';
import { DocumentFormFactoryService } from '../../../../../services/document-form-factory.service';
import { ClaimTypes } from '../../../../../model/claim-type.model';
import { SpinnerService } from '../../../../../core/spinner/spinner.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {Claim} from "../../../../../model/claim.model";

declare var $: any;

@Component({
    selector: 'app-curtailment-upload-document',
    templateUrl: './curtailment-upload-document.component.html',
    styleUrls: ['./curtailment-upload-document.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CurtailmentUploadDocumentComponent extends MultiClaimDocumentsComponent implements OnInit {

    public upLoadFileModel: FormGroup;
    showTotalBox = false;
    claim: Claim;

    constructor(private fb: FormBuilder,
        public sideMenuService: SideMenuService, 
        claimService: ClaimService,
        documentHelperService: DocumentHelperService,
        transactionInfoService: TransactionInfoService,
        http: HttpClient,
        documentFormFactoryService: DocumentFormFactoryService, spinnerService: SpinnerService, modalService: NgbModal) {
                super(claimService, documentHelperService, transactionInfoService, http, documentFormFactoryService, spinnerService, modalService);
                this.setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_CRTL]);
                this.setupMultiClaimant();
    }

    ngOnInit() {

        this.pushGAViewCurtailmentDocs();
        this.upLoadFileModel = this.fb.group(
            {
                originalItinerary: [],
                reportSupportCancel: [],
                prePaidReceipt: [],
                refundedAmountDoc: [],
                otherItems: this.fb.array([this.createItem()])

            });
            super.ngOnInit();
            this.claim = this.claimService.getClaim();
    }

    addFile() {
        let items = this.upLoadFileModel.get('otherItems') as FormArray;
        items.push(this.createItem());
    }

    createItem(): FormGroup {
        return this.fb.group({
            otherFile: []
        });
    }
    showModal() {
        this.showTotalBox = true;
    }
    getData(msg) {
        this.showTotalBox = msg;
    }
    goToNext() {
        this.sideMenuService.emitClaimComplete({claimTypeId: 8, subMenuIndex: 3});
        this.sideMenuService.emitProgress(1);
    }

    //Google Analytics
    pushGAViewCurtailmentDocs() {
        (<any>window).dataLayer.push({
            'pageStep': 'Trip Curtailment – Document Upload',
            'vPath': '/claim/trip-curtailment/documents',
            'event': 'vpageview',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 6},	//Step6-DocumentUpload
                }
            }
        });
    }
}
